<ion-card mode="ios" *ngIf="peers && peers.length > 0">
    <ion-card-header color="" [ngStyle]="peerHeaderWidth">
        <ion-card-title color="primary">
            {{ (titleKey ? titleKey : "performanceCycle.threeSixtyEvaluation") | translate | uppercase }}
        </ion-card-title>
    </ion-card-header>

    <ion-card-content class="ion-no-padding">
        <ng-container>
            <ng-container *ngIf="!scrollEnabled; else peerScrollEnabled">
                <ng-container *ngIf="genericQuestions">
                    <ion-grid class="team">
                        <ion-row class="header">
                            <ion-row class="topAlign">
                                <ion-col [size]="1" class="evaluator"></ion-col>
                                <ion-col [size]="11 / allGenericQuestions?.length"
                                         *ngFor="let question of genericQuestions; let index = index"
                                         [ngClass]="{
                                                  highlight:
                                                    question.type &&
                                                    question.type === QuestionConfigType.FinalGrade
                                                }"
                                         [innerHtml]="
                                                  getParsedDescription(
                                                    getText(question.globalizationConfig, 'title')
                                                  )
                                                "
                                ></ion-col>
                            </ion-row>
                        </ion-row>
                        <ion-row class="body" *ngFor="let evaluation of peers; let p1Index = index;">
                            <ion-row class="noBorder topAlign"
                                     [class.showLess]="!show.showP1Questions[p1Index] && showMoreLess"
                                     [class.showMore]="show.showP1Questions[p1Index] && showMoreLess"
                            >
                                <ion-col [size]="1" class="evaluator">
                                    <img
                                            default
                                            [src]="
                                                !evaluation.evaluator.external
                                                  ? getImageUrl(evaluation.evaluator.imageUrl)
                                                  : './assets/imgs/external-user-placeholder.png'
                                              "
                                            class="avatar"
                                            alt=""
                                    />
                                    <h3>{{ evaluation.user.name }}</h3>
                                </ion-col>
                                <ion-col [size]="11 / allGenericQuestions?.length"
                                         class="topAlign answer-column"
                                         *ngFor="let question of genericQuestions; let index = index"
                                         [ngClass]="{
                                                  highlight:
                                                    question.type &&
                                                    question.type === QuestionConfigType.FinalGrade
                                                }"
                                >
                                    <p>
                                        {{ evaluation["field" + (index + 1)] }}</p>
                                </ion-col>
                            </ion-row>
                            <ion-row *ngIf="showMoreLess" class="noBorder showClick" style="width: 100%">
                                <div (click)="show.showP1Questions[p1Index] = !show.showP1Questions[p1Index]"
                                     class="clickable">
                                    {{
                                    show.showP1Questions[p1Index]
                                        ? ("generic.showLess" | translate)
                                        : ("generic.showMore" | translate)
                                    }}
                                </div>
                            </ion-row>
                        </ion-row>
                    </ion-grid>
                </ng-container>

                <ng-container *ngIf="peerQuestions">
                    <ion-grid class="team">
                        <ion-row class="header">
                            <ion-row>
                                <ion-col [size]="1" class="evaluator"></ion-col>
                                <ng-container
                                        *ngFor="let group of peerQuestions; let gindex = index"
                                >
                                    <ion-col [size]="11 / allPeerQuestions?.length"
                                             *ngFor="let question of group.questions; let index = index"
                                             class="topAlign ion-text-center"
                                             [ngClass]="{
                                                        highlight:
                                                          question.type &&
                                                          question.type === QuestionConfigType.FinalGrade
                                                      }"
                                             [innerHtml]="
                                                        getParsedDescription(
                                                          getText(question.globalizationConfig, 'title')
                                                        )
                                                      "
                                    ></ion-col>
                                </ng-container>
                            </ion-row>
                        </ion-row>
                        <ion-row class="body" *ngFor="let evaluation of peers; let p2Index = index;">
                            <ion-row class="topAlign" no-lines
                                     [class.showLess]="!show.showP2Questions[p2Index] && showMoreLess"
                                     [class.showMore]="show.showP2Questions[p2Index] && showMoreLess"
                            >
                                <ion-col [size]="1" class="evaluator">
                                    <img
                                            default
                                            [src]="getImageUrl(evaluation.evaluator.imageUrl)"
                                            class="avatar"
                                            alt=""
                                    />
                                    <h3>{{ evaluation.evaluator.name }}</h3>
                                </ion-col>
                                <ng-container
                                        *ngFor="let group of peerQuestions; let gindex = index"
                                >
                                    <ion-col [size]="11 / allPeerQuestions?.length"
                                             class="topAlign answer-column"
                                             *ngFor="let question of group.questions; let index = index"
                                             [ngClass]="{
                                                        highlight:
                                                          question.type &&
                                                          question.type === QuestionConfigType.FinalGrade
                                                      }"
                                    >
                                        <p>
                                            {{
                                            getGlobalizedValue(
                                                evaluation["field" + question.order],
                                                question
                                            )
                                            }}
                                        </p>
                                    </ion-col>
                                </ng-container>
                            </ion-row>
                            <ion-row class="showMoreLessButton">
                                <div class="bottom">
                                    <ion-row *ngIf="showMoreLess" class="noBorder showClick" style="width: 100%">
                                        <div class="margin-top clickable"
                                             (click)="show.showP2Questions[p2Index] = !show.showP2Questions[p2Index]">
                                            {{
                                            show.showP2Questions[p2Index]
                                                ? ("generic.showLess" | translate)
                                                : ("generic.showMore" | translate)
                                            }}
                                        </div>
                                    </ion-row>
                                </div>
                            </ion-row>
                        </ion-row>
                    </ion-grid>
                </ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="peers && peers.length === 0">
            <p class="ion-padding">{{ "generic.noEvaluations" | translate }}</p>
        </ng-container>
    </ion-card-content>
</ion-card>

<ion-card mode="ios" *ngIf="subordinates && subordinates.length > 0">
    <ion-card-header color="" [ngStyle]="subordinateHeaderWidth">
        <ion-card-title color="primary">
            {{ "performanceCycle.threeSixtyEvaluationDirectReports" | translate | uppercase }}
        </ion-card-title>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
        <ng-container *ngIf="!scrollEnabled; else subordinateScrollEnabled">
            <ng-container *ngIf="genericQuestions">
                <ion-grid class="team">
                    <ion-row class="header topAlign">
                        <ion-col [size]="1" class="evaluator"></ion-col>
                        <ion-col [size]="11 / allGenericQuestions?.length" class="ion-text-center"
                                 *ngFor="let question of genericQuestions; let index = index"
                                 [ngClass]="{
                                                        highlight:
                                                          question.type &&
                                                          question.type === QuestionConfigType.FinalGrade
                                                      }"
                                 [innerHtml]="
                                                        getParsedDescription(
                                                          getText(question.globalizationConfig, 'title')
                                                        )
                                                      "
                        ></ion-col>
                    </ion-row>
                    <ion-row class="body topAlign" *ngFor="let evaluation of subordinates">
                        <ion-col [size]="1" class="evaluator">
                            <img
                                    default
                                    [src]="getImageUrl(evaluation.user.imageUrl)"
                                    class="avatar"
                                    alt=""
                            />
                            <h3>{{ evaluation.user.name }}</h3>
                        </ion-col>
                        <ion-col [size]="11 / allGenericQuestions?.length"
                                 *ngFor="let question of genericQuestions; let index = index"
                                 class="answer-column"
                                 [ngClass]="{
                                                        highlight:
                                                          question.type &&
                                                          question.type === QuestionConfigType.FinalGrade
                                                      }"
                        >
                            <p>
                                {{
                                getGlobalizedValue(
                                    evaluation["field" + question.order],
                                    question
                                )
                                }}
                            </p>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ng-container>

            <ng-container *ngIf="managerQuestions">
                <ion-grid class="team">
                    <ion-row class="header">
                        <ion-row class="topAlign">
                            <ion-col [size]="1" class="evaluator"></ion-col>
                            <ng-container class="container"
                                          *ngFor="let group of managerQuestions; let gindex = index"

                            >
                                <ion-col [size]="11 / allManagerQuestions.length"
                                         *ngFor="let question of group.questions; let index = index"
                                         class="topAlign ion-text-center"
                                         [ngClass]="{
                                                                highlight:
                                                                  question.type &&
                                                                  question.type === QuestionConfigType.FinalGrade
                                                              }"
                                         [innerHtml]="
                                                                getParsedDescription(
                                                                  getText(question.globalizationConfig, 'title')
                                                                )
                                                                "
                                ></ion-col>
                            </ng-container>
                        </ion-row>
                    </ion-row>
                    <ion-row class="body"
                             *ngFor="let evaluation of subordinates; let evalIndex = index"
                    >
                        <ion-row class="topAlign"
                                 [class.showLess]="!show.showQuestions[evalIndex] && showMoreLess"
                                 [class.showMore]="show.showQuestions[evalIndex] && showMoreLess"
                        >
                            <ion-col
                                    [size]="1" class="evaluator"
                                    [class.showLess]="show.showQuestions[evalIndex] && showMoreLess"
                                    [class.showMore]="show.showQuestions[evalIndex] && showMoreLess"
                            >
                                <img
                                        default
                                        [src]="getImageUrl(evaluation.evaluator.imageUrl)"
                                        class="avatar"
                                        alt=""
                                />
                                <h3>{{ evaluation.evaluator.name }}</h3>
                            </ion-col>
                            <ng-container class="container" *ngFor="let group of managerQuestions">
                                <ion-col [size]="11 / allManagerQuestions.length"
                                         *ngFor="let question of group.questions; let gindex = index"
                                         class="answer-column"
                                         [ngClass]="{
                                                                highlight:
                                                                  question.type &&
                                                                  question.type === QuestionConfigType.FinalGrade
                                                              }">
                                    {{
                                    getGlobalizedValue(
                                        evaluation["field" + question.order],
                                        question
                                    )
                                    }}
                                </ion-col>
                            </ng-container>
                        </ion-row>
                        <div class="bottom">
                            <ion-row *ngIf="showMoreLess" class="noBorder showClick" style="width: 100%">
                                <div class="margin-top clickable"
                                     (click)="
                                                  show.showQuestions[evalIndex] = !show.showQuestions[evalIndex]
                                                ">
                                    {{
                                    show.showQuestions[evalIndex]
                                        ? ("generic.showLess" | translate)
                                        : ("generic.showMore" | translate)
                                    }}
                                </div>
                            </ion-row>
                        </div>
                    </ion-row>
                </ion-grid>
            </ng-container>
        </ng-container>

    </ion-card-content>
</ion-card>


<!------------------------------------------------------------->
<!--                        TEMPLATES                        -->
<!------------------------------------------------------------->


<ng-template #peerScrollEnabled class="xScroll">
    <ng-container *ngIf="genericQuestions">
        <ion-grid class="team" [ngStyle]="{width: (((allGenericQuestions.length * 200) + 245) + 'px')}">
            <ion-row class="header">
                <ion-row class="topAlign">
                    <ion-col class="evaluator setFirstColWidth"><p class="setFirstColWidth"></p></ion-col>
                    <ion-col class="setWidth"
                             *ngFor="let question of genericQuestions; let index = index"
                             [ngClass]="{ highlight: question.type && question.type === QuestionConfigType.FinalGrade }">
                        <p class="setWidth questionHeader">
                            {{ getParsedDescription(getText(question.globalizationConfig, 'title')) }}
                        </p>
                    </ion-col>
                </ion-row>
            </ion-row>
            <ion-row class="body" *ngFor="let evaluation of peers; let p1Index = index;">
                <ion-row class="noBorder topAlign"
                         [class.showLess]="!show.showP1Questions[p1Index] && showMoreLess"
                         [class.showMore]="show.showP1Questions[p1Index] && showMoreLess"
                >
                    <ion-col class="evaluatorData setWidth">
                        <img
                                default
                                [src]="
                                                !evaluation.evaluator.external
                                                  ? getImageUrl(evaluation.evaluator.imageUrl)
                                                  : './assets/imgs/external-user-placeholder.png'
                                              "
                                class="avatar"
                                alt=""
                        />
                        <h3 class="setFirstColWidth">{{ evaluation.user.name }}</h3>
                    </ion-col>
                    <ion-col class="topAlign setWidth answer-column"
                             *ngFor="let question of genericQuestions; let index = index"
                             [ngClass]="{
                                                  highlight:
                                                    question.type &&
                                                    question.type === QuestionConfigType.FinalGrade
                                                }"
                    >
                        <p>
                            {{ evaluation["field" + (index + 1)] }}</p>
                    </ion-col>
                </ion-row>
                <ion-row *ngIf="showMoreLess" class="noBorder showClick" style="width: 100%">
                    <div class="clickable" (click)="show.showP1Questions[p1Index] = !show.showP1Questions[p1Index]">
                        {{
                        show.showP1Questions[p1Index]
                            ? ("generic.showLess" | translate)
                            : ("generic.showMore" | translate)
                        }}
                    </div>
                </ion-row>
            </ion-row>
        </ion-grid>
    </ng-container>

    <ng-container *ngIf="peerQuestions">
        <ion-grid class="team" [ngStyle]="{width: (((allPeerQuestions.length * 200) + 245) + 'px')}">
            <ion-row class="header">
                <ion-row>
                    <ion-col class="evaluator"><p class="setFirstColWidth"></p></ion-col>
                    <ng-container
                            *ngFor="let group of peerQuestions; let gindex = index"
                    >
                        <ion-col
                                 *ngFor="let question of group.questions; let index = index"
                                 class="topAlign setWidth ion-text-center"
                                 [ngClass]="{ highlight: question.type && question.type === QuestionConfigType.FinalGrade }">
                            <p class="setWidth questionHeader">
                                {{
                                getParsedDescription(
                                    getText(question.globalizationConfig, 'title')
                                )
                                }}
                            </p>
                        </ion-col>
                    </ng-container>
                </ion-row>
            </ion-row>
            <ion-row class="body" *ngFor="let evaluation of peers; let p2Index = index;">
                <ion-row class="topAlign" no-lines
                         [class.showLess]="!show.showP2Questions[p2Index] && showMoreLess"
                         [class.showMore]="show.showP2Questions[p2Index] && showMoreLess"
                >
                    <ion-col class="evaluator setWidth">
                        <img
                                default
                                [src]="getImageUrl(evaluation.evaluator.imageUrl)"
                                class="avatar"
                                alt=""
                        />
                        <h3 class="setFirstColWidth">{{ evaluation.evaluator.name }}</h3>
                    </ion-col>
                    <ng-container
                            *ngFor="let group of peerQuestions; let gindex = index"
                    >
                        <ion-col class="topAlign setWidth answer-column"
                                 *ngFor="let question of group.questions; let index = index"
                                 [ngClass]="{
                                                        highlight:
                                                          question.type &&
                                                          question.type === QuestionConfigType.FinalGrade
                                                      }"
                        >
                            <p class="setWidth">
                                {{
                                getGlobalizedValue(
                                    evaluation["field" + question.order],
                                    question
                                )
                                }}
                            </p>
                        </ion-col>
                    </ng-container>
                </ion-row>
                <ion-row class="showMoreLessButton">
                    <div class="bottom">
                        <ion-row *ngIf="showMoreLess" class="noBorder showClick" style="width: 100%">
                            <div class="margin-top clickable"
                                 (click)="
                                          show.showP2Questions[p2Index] = !show.showP2Questions[p2Index]
                                        ">
                                {{
                                show.showP2Questions[p2Index]
                                    ? ("generic.showLess" | translate)
                                    : ("generic.showMore" | translate)
                                }}
                            </div>
                        </ion-row>
                    </div>
                </ion-row>
            </ion-row>
        </ion-grid>
    </ng-container>
</ng-template>

<ng-template #subordinateScrollEnabled class="xScroll">
    <ng-container *ngIf="genericQuestions">
        <ion-grid class="team" [ngStyle]="{width: (((allGenericQuestions.length * 200) + 245) + 'px')}">
            <ion-row class="header topAlign">
                <ion-col class="evaluator setFirstColWidth"><p class="setFirstColWidth"></p></ion-col>
                <ion-col class="setWidth ion-text-center"
                         *ngFor="let question of genericQuestions; let index = index"
                         [ngClass]="{ highlight: question.type && question.type === QuestionConfigType.FinalGrade }">
                    <p class="setWidth questionHeader">
                        {{ getParsedDescription(getText(question.globalizationConfig, 'title')) }}
                    </p>
                </ion-col>
            </ion-row>
            <ion-row class="body topAlign" *ngFor="let evaluation of subordinates">
                <ion-col class="evaluator setWidth">
                    <img
                            default
                            [src]="getImageUrl(evaluation.user.imageUrl)"
                            class="avatar"
                            alt=""
                    />
                    <h3 class="setFirstColWidth">{{ evaluation.user.name }}</h3>
                </ion-col>
                <ion-col class="setWidth answer-column"
                         *ngFor="let question of genericQuestions; let index = index"
                         [ngClass]="{ highlight: question.type && question.type === QuestionConfigType.FinalGrade }"
                >
                    <p class="setWidth">
                        {{ getGlobalizedValue(evaluation["field" + question.order], question) }}
                    </p>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ng-container>

    <ng-container *ngIf="managerQuestions">
        <ion-grid class="team" [ngStyle]="{width: (((allManagerQuestions.length * 200) + 245) + 'px')}">
            <ion-row class="header">
                <ion-row class="topAlign">
                    <ion-col class="evaluator setFirstColWidth"><p class="setFirstColWidth"></p></ion-col>
                    <ng-container class="container"
                                  *ngFor="let group of managerQuestions; let gindex = index">
                        <ion-col class="topAlign setWidth ion-text-center"
                                 *ngFor="let question of group.questions; let index = index"
                                 [ngClass]="{ highlight: question.type && question.type === QuestionConfigType.FinalGrade }">
                            <p class="setWidth questionHeader">
                                {{ getParsedDescription(getText(question.globalizationConfig, 'title')) }}
                            </p>
                        </ion-col>
                    </ng-container>
                </ion-row>
            </ion-row>
            <ion-row class="body"
                     *ngFor="let evaluation of subordinates; let evalIndex = index"
            >
                <ion-row class="topAlign"
                         [class.showLess]="!show.showQuestions[evalIndex] && showMoreLess"
                         [class.showMore]="show.showQuestions[evalIndex] && showMoreLess"
                >
                    <ion-col class="evaluator setWidth"
                             [class.showLess]="show.showQuestions[evalIndex] && showMoreLess"
                             [class.showMore]="show.showQuestions[evalIndex] && showMoreLess"
                    >
                        <img
                                default
                                [src]="getImageUrl(evaluation.evaluator.imageUrl)"
                                class="avatar"
                                alt=""
                        />
                        <h3 class="setFirstColWidth">{{ evaluation.evaluator.name }}</h3>
                    </ion-col>
                    <ng-container class="container" *ngFor="let group of managerQuestions">
                        <ion-col class="setWidth"
                                 *ngFor="let question of group.questions; let gindex = index"
                                 [ngClass]="{ highlight: question.type && question.type === QuestionConfigType.FinalGrade }">
                            <p class="setWidth answer-column">
                                {{ getGlobalizedValue(evaluation["field" + question.order], question) }}
                            </p>
                        </ion-col>
                    </ng-container>
                </ion-row>
                <div class="bottom">
                    <ion-row *ngIf="showMoreLess" class="noBorder showClick" style="width: 100%">
                        <div class="margin-top clickable"
                             (click)="show.showQuestions[evalIndex] = !show.showQuestions[evalIndex]">
                            {{
                            show.showQuestions[evalIndex]
                                ? ("generic.showLess" | translate)
                                : ("generic.showMore" | translate)
                            }}
                        </div>
                    </ion-row>
                </div>
            </ion-row>
        </ion-grid>
    </ng-container>
</ng-template>